import Com from '../detail';
import css from './index.module.scss';
import CrowdFundingPC from '@/components/CrowdFunding';
import { useGlobal } from '@/utils/useGlobal';
import { bundleData } from '@/data/crowdfunding/wave2';
import { ACTIVITY_MAP } from '@/constants/wave2';

export default function CrowdFunding({ productDetail, resProductCatagory, nowSysTime, supportData, crowdfundingTimeline }: any) {
    const { useRouter, useLang } = useGlobal();
    const { t } = useLang('wave2portableairconditioner');
    const { locale } = useRouter();
    const bundlesData = bundleData[locale] || bundleData.us;
    const activityId = ACTIVITY_MAP[locale] || ACTIVITY_MAP.us;
    const bannerData = {
        // 1.EFPic 2.Image 建议1
        swiperImgs: ['us', 'ca', 'br', 'mx'].includes(locale)
            ? [
                  `/media/wave2/crowdfunding/pc/banner_na.mp4`,
                  `/media/wave2/crowdfunding/pc/banner1_na.jpg`,
                  `/media/wave2/crowdfunding/pc/banner2_na.png`,
                  `/media/wave2/crowdfunding/pc/banner3_na.jpg`,
                  `/media/wave2/crowdfunding/pc/banner4_na.jpg`,
              ]
            : [
                  `/media/wave2/crowdfunding/pc/banner1${locale === 'jp' ? '_jp' : ''}.jpg`,
                  `/media/wave2/crowdfunding/pc/banner2${locale === 'jp' ? '_jp' : ''}.jpg`,
                  `/media/wave2/crowdfunding/pc/banner5${locale === 'jp' ? '_jp' : ''}.jpg`,
                  `/media/wave2/crowdfunding/pc/banner3${locale === 'jp' ? '_jp' : ''}.jpg`,
                  `/media/wave2/crowdfunding/pc/banner4${locale === 'jp' ? '_jp' : ''}.jpg`,
              ],
        webpUrl: '',
        subTitle: ['us', 'ca', 'br', 'mx'].includes(locale) ? t('crowdfunding.header.subtitle') : '',
        title: t('crowdfunding.header.title'),
        desc: t.rich('crowdfunding.header.desc', {
            dot: (text: string) => <span className="dot">{text}</span>,
        }),
        tip: ['us', 'ca'].includes(locale) ? t('crowdfunding.header.tip') : '',
        showTC: ['us', 'ca', 'jp', 'br', 'mx'].includes(locale), // 是否显示问号 T&C内容弹窗
        showShareLinks: !['us', 'ca', 'br', 'mx'].includes(locale),
        productKey: 'wave2',
        buyNowText: ['us', 'ca'].includes(locale) ? t('crowdfunding.header.btn') : undefined,
        buyNowLink: ['us', 'ca'].includes(locale)
            ? `/${locale}/wave-3-portable-air-conditioner`
            : ['br', 'mx'].includes(locale)
            ? `https://${locale}.ecoflow.com/products/wave-2-portable-air-conditioner`
            : '',
        // promotion: t('crowdfunding.header.summer_promotion_wave2'), // 欧洲6站夏日促销文案
    };

    const shopifyBtnProps = {
        /// domain & token
        options: (() => {
            const map: any = {};
            return map[locale] || null;
        })(),
        // 购物车
        cartText: {
            title: t('crowdfunding.shopify_btn.title'),
            total: t('crowdfunding.shopify_btn.total'),
            empty: t('crowdfunding.shopify_btn.empty'),
            notice: t('crowdfunding.shopify_btn.notice'),
            button: t('crowdfunding.shopify_btn.button'),
        },
    };
    return (
        <div className={`blade-crowdfunding ${css.bladeCrowdfunding}`}>
            <CrowdFundingPC
                productDetail={productDetail}
                resProductCatagory={resProductCatagory}
                nowSysTime={nowSysTime}
                crowdfundingTimeline={crowdfundingTimeline}
                shopifyBtnProps={shopifyBtnProps}
                bundlesData={bundlesData}
                supportData={supportData}
                bannerData={bannerData}
                activityId={activityId}
                getShopifyPrice={['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale)}
                hideBundles={['us', 'ca', 'br', 'mx'].includes(locale)}
                Com={Com}
            />
            <style jsx global>
                {`
                    .product_naver {
                        display: none;
                    }
                `}
            </style>
        </div>
    );
}
